import { render, staticRenderFns } from "./VoyagerLogin.vue?vue&type=template&id=397b9d12&"
import script from "./VoyagerLogin.vue?vue&type=script&lang=js&"
export * from "./VoyagerLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports